import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { useDispatch } from "react-redux";
import { mapUnit } from "../../../actions/unitActions";
import { useSnackbar } from "react-simple-snackbar";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  root: { margin: 0, padding: theme.spacing(2), backgroundColor: "#ef7f1a" },
  closeButton: { position: "absolute", right: theme.spacing(1), top: theme.spacing(1), color: "white" },
  inputStyle: { width: "100%" },
}));

const DialogTitle = (props) => {
  const classes = useStyles();
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...props}>
      <Typography variant="h6">{props.children}</Typography>
      {props.onClose ? (
        <IconButton className={classes.closeButton} onClick={props.onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

const MapUnit = ({ open, setOpen, units, editMapping }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [openSnackbar] = useSnackbar();
  const [mappingData, setMappingData] = useState({ fromUnitId: null, toUnitId: null, conversionFactor: "" });
  const [selectedFromUnit, setSelectedFromUnit] = useState(null);
  const [selectedToUnit, setSelectedToUnit] = useState(null);

  useEffect(() => {
    if (open && editMapping) {
      setMappingData({
        id: editMapping.id,
        fromUnitId: editMapping.fromUnit.id,
        toUnitId: editMapping.toUnit.id,
        conversionFactor: editMapping.conversionFactor.toString(),
      });
      setSelectedFromUnit(editMapping.fromUnit);
      setSelectedToUnit(editMapping.toUnit);
    } else {
      clear();
    }
  }, [open, editMapping]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (mappingData.fromUnitId && mappingData.toUnitId && mappingData.conversionFactor) {
      dispatch(mapUnit(mappingData, openSnackbar));
      clear();
      setOpen(false);
      window.location.reload();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMappingData((prev) => ({ ...prev, [name]: value }));
  };

  const clear = () => {
    setMappingData({ fromUnitId: null, toUnitId: null, conversionFactor: "" });
    setSelectedFromUnit(null);
    setSelectedToUnit(null);
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
      <DialogTitle onClose={() => setOpen(false)}>
        {editMapping ? "Edit Unit Mapping" : "Map Unit"}
      </DialogTitle>
      <MuiDialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              options={units}
              getOptionLabel={(unit) => `${unit.name} | ${unit.abbreviation}`}
              value={selectedFromUnit}
              onChange={(e, newValue) => {
                setSelectedFromUnit(newValue);
                setMappingData((prev) => ({ ...prev, fromUnitId: newValue ? newValue.id : null }));
              }}
              renderInput={(params) => <TextField {...params} label="From Unit" variant="outlined" />}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              options={units}
              getOptionLabel={(unit) => `${unit.name} | ${unit.abbreviation}`}
              value={selectedToUnit}
              onChange={(e, newValue) => {
                setSelectedToUnit(newValue);
                setMappingData((prev) => ({ ...prev, toUnitId: newValue ? newValue.id : null }));
              }}
              renderInput={(params) => <TextField {...params} label="To Unit" variant="outlined" />}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Conversion Factor"
              name="conversionFactor"
              variant="outlined"
              className={classes.inputStyle}
              type="number"
              value={mappingData.conversionFactor}
              onChange={handleChange}
              required
            />
          </Grid>
        </Grid>
      </MuiDialogContent>
      <MuiDialogActions>
        <Button onClick={handleSubmit} variant="contained" style={{ backgroundColor: "#ef7f1a", color: "white" }}>
          {editMapping ? "Update Mapping" : "Map Unit"}
        </Button>
      </MuiDialogActions>
    </Dialog>
  );
};

export default MapUnit;